import "@app/style/index.scss";
import App from "@app/app";
export default App;
